<template>
  <div class="lawyer-list-item border" @click="toDetails">
    <img class="avatarImage m-r-15" :src="avatar" />
    <div class="f-1 f-column">
      <div class="f-y-center relative f-between m-b-25">
        <div class="f-y-center">
          <div class="font-lg p-r-20">{{name}}</div>
          <div class="font-sm darkgray-font p-l-20 border-l">{{lawOffice}}</div>
        </div>
        <div class="shareImageBox">
          <img class="shareImage" src="@/assets/share.png" />
        </div>
      </div>
      <div class="flex m-b-20">
        <div class="font-sm darkgray-font m-r-10">已服务客户</div>
        <div class="font-sm blue-font">{{serveNum}}</div>
      </div>
      <div class="strengths">
        <img class="popularImage m-r-20" src="@/assets/popular.png" />
        <div class="font-sm darkgray-font">{{popular}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onBeforeMount } from 'vue'
import router from '@/router'
import { getUrlQuery, isUrl } from '@/utils/url.js'
import { fileApi } from '@/apis'
// /news/details/:id
export default {
  props: {
    name: String,
    lawOffice: String,
    avatar: String,
    serveNum: String,
    popular: String,
  },
  setup(props, { emit }) {
    const toDetails = () => {
      router.push('/lawyer/details/2')
    }
    return { toDetails }
  },
}
</script>

<style lang="scss">
.lawyer-list-item {
  display: flex;
  align-items: start;
  justify-content: start;
  padding: 25px 20px 25px 20px;
  background-color: #fff;

  .avatarImage {
    width: 92px;
    height: 92px;
    border-radius: 50%;
  }
  .strengths {
    display: flex;
    align-items: center;
    padding: 15px 15px 15px 20px;
    background-color: #f4f6f9;
    border-radius: 6px;
  }
  .popularImage {
    width: 24px;
    height: 32px;
  }
  .shareImageBox {
    position: absolute;
    top: -20px;
    right: 0;
    padding: 20px;
  }
  .shareImage {
    width: 32px;
    height: 32px;
  }
}
</style>